import React from "react"
import LanguagePicker from '../shared/LanguagePicker'

export default function Header({ appProps, logo }) {
  return (
    <header className="header_wrapper">
      <div className='logotype'>
        <img src={ appProps.logo } alt='logotype' />
      </div>
      <LanguagePicker className='header-language-picker' />
    </header>
  )
}
